export const vehicleWeekendsArr = [
  { name: "Monday", value: "mondayWeekend", index: 1 },
  { name: "Tuesday", value: "tuesdayWeekend", index: 2 },
  { name: "Wednesday", value: "wednesdayWeekend", index: 3 },
  { name: "Thursday", value: "thursdayWeekend", index: 4 },
  { name: "Friday", value: "fridayWeekend", index: 5 },
  { name: "Saturday", value: "saturdayWeekend", index: 6 },
  { name: "Sunday", value: "sundayWeekend", index: 7 },
];
